import { useEffect, useState } from "react";
import { berlinDateString } from "@/lib/brain/time";

const TICK_MS = 5 * 60_000;

/**
 * Today's Europe/Berlin date (YYYY-MM-DD), re-checked every 5 minutes. A memo
 * keyed on it re-derives date-threshold cards after Berlin midnight even when
 * no data changed; between days it never re-renders anything.
 */
export function useBerlinDay(): string {
  const [day, setDay] = useState(() => berlinDateString(new Date()));
  useEffect(() => {
    const id = setInterval(() => setDay(berlinDateString(new Date())), TICK_MS);
    return () => clearInterval(id);
  }, []);
  return day;
}
